import React from "react";
import { formValueSelector, reduxForm } from "redux-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import cx from "classnames";

import { openHeaderModal, closeHeaderModal } from "../../actions/siteadmin/modalActions";

import messages from "../../locale/messages";

import { createBookingAction } from "../../actions/booking/createBookingAction";
import withStyles from "isomorphic-style-loader/withStyles";
import { LightBulbIcon, PreferredProviderIcon, RandomProviderIcon, RightArrowIcon } from "../Common/Assets/SVGIcon/CommonSvgIcon";
import bt from '../commonStyle.css';
import s from './ProviderSelectionForm.css';

function ProviderSelectionForm({ formData }) {

    const promoId = useSelector(state => formValueSelector('PromoCodeForm')(state, 'promoId'))
    const isPromoIdRemove = useSelector(state => formValueSelector('PromoCodeForm')(state, 'isPromoIdRemove'))
    const paymentMethodId = useSelector(state => formValueSelector('PaymentMethod')(state, 'paymentMethodId'))
    const description = useSelector(state => formValueSelector('OrderDetails')(state, 'description'))
    const isRandomProviderEnable = useSelector(state => state?.siteSettings?.data?.randomProviderSelection)
    const isPreferredProviderEnable = useSelector(state => state?.siteSettings?.data?.preferredProviderSelection)

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(closeHeaderModal('providerSelectionForm'))
        dispatch(openHeaderModal('bookingForm'))
    }

    const handleRadomProviderAction = async () => {
        const bookingData = formData?.bookingData;
        const orderItem = bookingData?.orderItemsList?.[0];

        const orderId = bookingData?.id;
        const requestCurrency = bookingData?.currency;
        const reviewDescription = description?.trim() ? description : null;

        const dropOffLocation = orderItem?.dropLocation;
        const dropOffLat = orderItem?.dropLat;
        const dropOffLng = orderItem?.dropLng;

        const validPromoId = !isPromoIdRemove
            ? promoId ?? bookingData?.promoId
            : null;

        dispatch(closeHeaderModal('providerSelectionForm'))
        dispatch(openHeaderModal('nearestProviderForm'))

        await dispatch(createBookingAction({ orderId, requestCurrency, reviewDescription, dropOffLocation, dropOffLat, dropOffLng, promoId: validPromoId, paymentType: Number(paymentMethodId) }))

    }

    const preferredProviderAction = () => {
        dispatch(closeHeaderModal('providerSelectionForm'))
        dispatch(openHeaderModal('preferredProviderForm'))
    }

    return (
        <>
            <div className={s.providerSectionCardWrapper}>
                {isPreferredProviderEnable == '1' && <div onClick={() => preferredProviderAction()} className={s.providerSectionCard}>
                    <div className={s.cardHeaderContainer}>
                        <div className={s.cardHeaderInnerFlexWrapper}>
                            <PreferredProviderIcon />
                            <h5 className={s.cardHeading}>{formatMessage(messages.preferredProviderLabel)}</h5>
                        </div>
                        <RightArrowIcon className={'iconRotate'} />
                    </div>
                    <div className={s.cardDescriptionContainer}>
                        <LightBulbIcon />
                        <p className={s.cardDescription}>{formatMessage(messages.preferredProviderSectionContent)}</p>
                    </div>
                </div>}
                {isRandomProviderEnable == '1' && <div onClick={() => handleRadomProviderAction()} className={s.providerSectionCard}>
                    <div className={s.cardHeaderContainer}>
                        <div className={s.cardHeaderInnerFlexWrapper}>
                            <RandomProviderIcon />
                            <h5 className={s.cardHeading}>{formatMessage(messages.radomProviderLabel)}</h5>
                        </div>
                        <RightArrowIcon className={'iconRotate'} />
                    </div>
                    <div className={s.cardDescriptionContainer}>
                        <LightBulbIcon />
                        <p className={s.cardDescription}>{formatMessage(messages.radomProviderSectionContent)}</p>
                    </div>
                </div>}
            </div>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={() => handleClick()} className={cx(bt.btnSecondary, bt.cursorPointer)} ><FormattedMessage {...messages.goBackText} /> </Button>
            </div>
        </>
    )
}

ProviderSelectionForm = reduxForm({
    form: 'ProviderSelectionForm',
})(ProviderSelectionForm);

export default withStyles(bt, s)(ProviderSelectionForm)